var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlogListing',{attrs:{"posts":_vm.posts,"current-page":1,"total-pages":_vm.totalPages,"hub-tags":_vm.hubTags}})
}
var staticRenderFns = []

export { render, staticRenderFns }